import { Clause, LegalPage, SUPPORT_EMAIL } from "@/components/store/LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      testId="refund-page"
      eyebrow="Refund policy"
      title="No refunds. All sales are final."
      intro="Please read this before you pay. Last updated June 2026."
    >
      <div className="rounded-sm border border-primary/30 bg-[#F6EFE9] p-6">
        <p className="font-display text-lg font-semibold text-primary">No Refund</p>
        <p className="mt-2 text-[15px] leading-relaxed">
          Once a payment is completed, the order cannot be cancelled, returned, exchanged or refunded — in part or in full.
          This applies to paperbacks, hardcovers, personalised signed copies and ebooks alike.
        </p>
      </div>

      <Clause heading="Why">
        <p>Every copy is packed by hand and dispatched by a single poet, not a warehouse. Signed and dedicated copies are written personally for you and cannot be resold, so we are unable to accept returns or issue refunds.</p>
      </Clause>

      <Clause heading="No cancellations">
        <p>Orders cannot be cancelled after payment. Before paying, please check the edition you have chosen (paperback or hardcover), the quantity, the spelling of any dedication and your full shipping address with PIN code and phone number.</p>
      </Clause>

      <Clause heading="If your parcel is delayed or lost">
        <p>We will help. Write to <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-primary hover:underline">{SUPPORT_EMAIL}</a> with your order number and we will chase the courier on your behalf and share every update we get. Where a courier formally confirms that a parcel has been lost in transit, we will send a replacement copy at no extra cost — a replacement, not a refund.</p>
      </Clause>

      <Clause heading="If a parcel is returned to us">
        <p>Parcels returned because of an incomplete or incorrect address, an unreachable phone number, or repeated refusal of delivery can be re-shipped once fresh shipping charges are paid. The amount already paid for the book is not refunded.</p>
      </Clause>

      <Clause heading="Payment failures and duplicate charges">
        <p>If money leaves your account but the order does not appear as paid, nothing is lost: such amounts are automatically reversed by your bank or by Cashfree, usually within 5–7 working days. If a genuine duplicate charge is made for the same order, write to us with the payment reference and we will have it returned to you.</p>
      </Clause>

      <Clause heading="Questions before buying">
        <p>If you are unsure about anything — the edition, the shipping time, a bulk or gift order — please ask us first at <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-primary hover:underline">{SUPPORT_EMAIL}</a>. We would much rather answer a question than disappoint you after a sale.</p>
      </Clause>
    </LegalPage>
  );
}
